// @flow
export type { default as DeviceInfo } from './DeviceInfo';

export {
    default as getDeviceInfo,
    createDeviceInfoFromCookies,
    createDeviceInfoFromHeader,
} from './deviceDetector';
